import { FlexColumn } from '@editor/components/utilities/layouts';
import { P3 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const Wrapper = styled(FlexColumn)`
  position: relative;
`;

export const TableRow = styled.div`
  display: flex;
  width: 100%;

  > :nth-child(1) {
    margin-right: 12px;
    flex-grow: 1;
  }

  > :nth-child(2) {
    flex-shrink: 0;
    min-width: 90px;
  }

  ${QUERIES.laptopAndUp} {
    > &:nth-child(1) {
      margin-right: 6px;
    }
  }
`;

export const CardInfo = styled.a`
  display: flex;
  justify-content: end;
  align-items: center;
  text-transform: capitalize;
  text-decoration: none;

  > * {
    cursor: pointer;
  }
`;

export const PromoCodeHighlight = styled(P3)`
  color: ${themeStyle.varHighlight};
`;
